(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/prescript.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/prescript.js');
"use strict";


svs = svs || {};
svs.kenoXpress = svs.kenoXpress || {};
svs.kenoXpress.react = svs.kenoXpress.react || {};
svs.kenoXpress.react.utils = svs.kenoXpress.react.utils || {};
svs.kenoXpress.react.hooks = svs.kenoXpress.react.hooks || {};
svs.kenoXpress.logger = new svs.core.log.Logger('kenoXpress');

 })(window);